"use client";

import { useState } from "react";
import {
  Label,
  Listbox,
  ListboxButton,
  ListboxOption,
  ListboxOptions,
} from "@headlessui/react";
import { ChevronUpDownIcon } from "@heroicons/react/16/solid";
import { CheckIcon } from "@heroicons/react/20/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileExcel,
  faFilePdf,
  faFileZipper,
} from "@fortawesome/free-regular-svg-icons";
import DownloadNotifications from "../Notifications/DownloadNotifications";

export default function ExportMenu({
  exportExcel,
  exportDocs,
  notification,
  setNotification,
  fileType,
  details,
  downloadFileName,
}) {
  const [downloadNotificationOpen, setDownloadNotificationOpen] =
    useState(false);

  const exportMenu = [
    {
      id: 1,
      name: "Excel - Responses only",
      icon: (
        <FontAwesomeIcon
          icon={faFileExcel}
          className="w-[16px] h-[16px] text-green-700"
        />
      ),
      method: () => exportExcel("excel"),
    },
    {
      id: 2,
      name: "PDF - Documents only",
      icon: (
        <FontAwesomeIcon
          icon={faFilePdf}
          className="w-[16px] h-[16px] text-red-700"
        />
      ),
      method: () => exportExcel("pdf"),
    },
    {
      id: 3,
      name: "Responses + Documents in Excel",
      icon: (
        <FontAwesomeIcon
          icon={faFileZipper}
          className="w-[16px] h-[16px] text-rose-700"
        />
      ),
      method: () => exportDocs("excel"),
    },
    {
      id: 4,
      name: "Responses + Documents in PDF",
      icon: (
        <FontAwesomeIcon
          icon={faFileZipper}
          className="w-[16px] h-[16px] text-rose-700"
        />
      ),
      method: () => exportDocs("pdf"),
    },
  ];
  const [selected, setSelected] = useState();
  return (
    <Listbox value={selected} onChange={setSelected}>
      <div className="relative mt-2 w-80">
        {" "}
        {/* Increased width here */}
        <ListboxButton className="grid w-80 cursor-default grid-cols-1 rounded-md bg-white py-1.5 pl-3 pr-2 text-left text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6">
          <span className="col-start-1 row-start-1 flex items-center gap-3 pr-6">
            {selected ? (
              <>
                <span>{selected.icon}</span>
                <span className="block truncate">{selected.name}</span>
              </>
            ) : (
              <span className="text-gray-400">Select export option...</span>
            )}
          </span>
          <ChevronUpDownIcon
            aria-hidden="true"
            className="col-start-1 row-start-1 size-5 self-center justify-self-end text-gray-500 sm:size-4"
          />
        </ListboxButton>
        <ListboxOptions
          transition
          className="absolute z-10 mt-1 max-h-56 w-80 overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none data-[closed]:data-[leave]:opacity-0 data-[leave]:transition data-[leave]:duration-100 data-[leave]:ease-in sm:text-sm"
        >
          {exportMenu.map((item) => (
            <ListboxOption
              key={item.id}
              value={item}
              className="group relative cursor-pointer select-none py-2 pl-3 pr-9 text-gray-900 data-[focus]:bg-gray-50 data-[focus]:outline-none"
            >
              <div className="flex items-center" onClick={() => item.method()}>
                <span className="group-data-[focus]:text-white">
                  {item.icon}
                </span>
                <span className="ml-3 block truncate font-normal group-data-[selected]:font-semibold">
                  {item.name}
                </span>
              </div>
              <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-indigo-600 group-[:not([data-selected])]:hidden group-data-[focus]:text-white">
                <CheckIcon aria-hidden="true" className="size-5" />
              </span>
            </ListboxOption>
          ))}
        </ListboxOptions>
      </div>

      <DownloadNotifications
        show={notification}
        setShow={setNotification}
        fileType={fileType}
        id={details?.questionnaire_id}
        name={details?.name}
        downloadFileName={downloadFileName}
      />
    </Listbox>
  );
}
